import { jsPDF } from "jspdf";
import { httpGet, httpPost, httpPatch } from "./api";

const XLSX = require("xlsx");

function DownloadFile(data, name) {

	const workbook = XLSX.utils.book_new();


	for (let i = 0; i < Object.keys(data).length; i++) {
		
		let worksheet = XLSX.utils.json_to_sheet(Object.values(data)[i]);

		//replace \ / ? * [ ] with _ in sheet name
		let sheetName = Object.keys(data)[i].replace(/[\\/?*[\]{}]/g, '_').substring(0, 31);

		XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
	}

	XLSX.writeFile(workbook, name + '.xlsx');
}

function countWrappedLines(text, max) {
    const wrapped = text_wrap(text, max);
    return (wrapped.match(/\n/g) || []).length;
}

function text_wrap(text, max) {
    let wrappedText = '';
    let line = '';
    const words = text.split(' '); // Split the text into words

    words.forEach((word) => {
        // Check if adding the next word exceeds the max width
        if (line.length + word.length + 1 > max) {
            // If the line is empty, we have to force a break
            if (line.length === 0) {
                // Break the word if it's longer than max
                for (let i = 0; i < word.length; i += max) {
                    wrappedText += word.slice(i, i + max) + '\n';
                }
            } else {
                wrappedText += line.trim() + '\n'; // Add the current line to the wrapped text
                line = word + ' '; // Start a new line with the current word
            }
        } else {
            line += word + ' '; // Add the word to the current line
        }
    });

    // Add any remaining text to the wrapped text
    wrappedText += line.trim();

    return wrappedText;
}


async function ExportMessages(messages, name) {
    console.log(messages)
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Ticket Export", 105, 20, { align: "center" });

    let y = 40;

    for (const msg of messages) {
      let sender = text_wrap(`${msg.first_name} ${msg.second_name} [${formatDate(new Date(msg.date_created))}]`, 90);
      let content = text_wrap(msg.content, 90);

      doc.rect(18, y-5, 180, 8);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(
        sender,
        20,
        y
      );

      y += countWrappedLines(sender) * 6 || 8;

      doc.setFont("helvetica", "normal");
      doc.text(content || "", 30, y);
      y += countWrappedLines(content) * 6 || 6;

      if (msg.attachment && ["png", "jpg", "jpeg", "gif"].includes(msg.attachment.split(".").slice(-1)[0])) {
        // convert image URL → base64
        const response = await httpGet(process.env.REACT_APP_URL_BASE + "/message/files/" + msg.id);

        if (response.status === 200) {

          const blob = await response.blob();
          const base64Img = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

          const imgWidth = 6*25;
          const imgHeight = 4*25; // you can calculate ratio here if needed

          if (y + imgHeight > 280) {
            doc.addPage();
            y = 20;
          }

          doc.addImage(base64Img, "JPEG", 30, y, imgWidth, imgHeight);
          y += imgHeight + 10;
        }

      }

      y += 6;
    }

    doc.save(name + ".pdf");
}

async function FileToB64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

function shortenText(text, startLen = 10, endLen = 10, ellipsis = ' ...... ') {
  if (text.length <= startLen + endLen) return text;
  return text.slice(0, startLen) + ellipsis + text.slice(-endLen);
}

function formatDate(date) {
  return date
    .toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
    .replace(',', '');
}


export {
	DownloadFile,
  ExportMessages,

	FileToB64,

  validateEmail,

	formatDate,
  shortenText
}